import {extend} from 'flarum/common/extend';
import app from 'flarum/common/app';
import CommentPost from 'flarum/common/components/CommentPost';
import DiscussionPage from 'flarum/common/components/DiscussionPage';
import DiscussionControls from 'flarum/common/utils/DiscussionControls';
import LogInModal from 'flarum/common/components/LogInModal';


app.initializers.add('nhanchaukp/login-to-see', () => {
	extend(CommentPost.prototype, 'content', function()
	{
	    if (app.session.user && app.current instanceof DiscussionPage)
	        $('.login2see_login').off('click').on('click',
	            () => DiscussionControls.loginAction.call(app.current.discussion, true, false)
	        );
	    else
	        $('.login2see_login').off('click').on('click',
	            () => app.modal.show(LogInModal)
	        );
	});
});
